// firebaseConfig.js
// Configuration for your DEFAULT Firebase Project
const defaultFirebaseConfig = {
  apiKey: process.env.VUE_APP_API_KEY,
  authDomain: process.env.VUE_APP_AUTH_DOMAIN,
  databaseURL: process.env.VUE_APP_DATABASE_URL,
  projectId: process.env.VUE_APP_PROJECT_ID,
  storageBucket: process.env.VUE_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_MESSAGING_SENDER_ID,
  appId: process.env.VUE_APP_APPID,
  measurementId: process.env.VUE_APP_MEASUREMENT_ID
};

// Configuration for your new 'CustomerProfile' Firebase Project
const customerProfileFirebaseConfig = {
  apiKey: process.env.VUE_APP_OTP_API_KEY,
  authDomain: process.env.VUE_APP_OTP_AUTH_DOMAIN,
  projectId: process.env.VUE_APP_OTP_PROJECT_ID,
  storageBucket: process.env.VUE_APP_OTP_STORAGE_BUCKET,
  databaseURL: process.env.VUE_APP_OTP_DATABASE_URL,
  messagingSenderId: process.env.VUE_APP_OTP_MESSAGING_SENDER_ID,
  appId: process.env.VUE_APP_OTP_APP_ID,
  measurementId: process.env.VUE_APP_OTP_MEASUREMENT_ID
};

// Export both configurations
export {
  defaultFirebaseConfig,
  customerProfileFirebaseConfig
};
